import ReactDOM from 'react-dom';
import {bindable, customElement, inject, noView} from 'aurelia-framework';

import RoutingMap from './maps/routing-map';
import {GoogleApiWrapper} from "google-maps-react";
import {Client} from "../../api/client";

@noView()
@inject(Element, Client)
@customElement('sio-tourism-bus-routing-map')
export class BusRoutingMap {

    @bindable data;
    @bindable routes;

    reactComponent = {};
    client;
    apikey = '';
    language = '';

    constructor(element, client) {
        this.element = element;
        this.client = client;
    }

    async render() {
        const resolveLocations = async (route) => {
            let markers = [];
            const locations = route?.routeLocations ?? route?.locations ?? [];

            for (const location of locations) {
                let data;
                if (
                    location?.title &&
                    location?.address &&
                    location?.coordinates
                ) {
                    data = Promise.resolve(location);
                } else {
                    const {modelId, id} = location;
                    data = await this.client.get(`${modelId}/${id}`);
                }

                let {title, address} = await data;
                const {coordinates} = address;

                title = title.concat('\n' + address.addressLine1);
                title = title.concat(', ' + address.zip + ' ' + address.city);
                if (address.country) title = title.concat(', ' + address.country);
                if (address.region) title = title.concat('\n' + address.region);

                markers.push({
                    lat: coordinates.lat,
                    lng: coordinates.lng,
                    title: title,
                    color: route.color ?? 'red'
                });
            }

            return markers;
        };

        const decodePolylines = (route) => {
            if (!route.directionPolylines?.length) return [];
            return {
                polylines: route.directionPolylines
                    .filter(item => item.polyline)
                    .map(item => item.polyline),
                color: route.color ?? 'red'
            };
        };

        const inputRoutes = Array.isArray(this.routes) && this.routes.length > 0
            ? this.routes
            : this.data ? [this.data] : [];

        let allMarkers = [];
        let allPolylines = [];

        for (const route of inputRoutes) {
            const markers = await resolveLocations(route);
            const lines = decodePolylines(route);
            allMarkers.push(markers);
            allPolylines.push(lines);
        }

        this.reactComponent = ReactDOM.render(
            <GoogleRoutingMap
                routes={inputRoutes}
                markers={allMarkers}
                polylines={allPolylines}
                apiKey={this.apikey}
                language={this.language}
            />,
            this.element
        );


    }

    async bind() {
        const settings = await this.client.get('maps/google/apikey');
        if (settings) {
            this.apikey = settings.apiKey ?? '';
            this.language = settings.locale ?? 'en';
        }

        GoogleRoutingMap = GoogleApiWrapper({
            apiKey: this.apikey,
            language: this.language
        })(RoutingMap);

        await this.render();
    }

    dataChanged(newValue, oldValue) {
        if (newValue !== oldValue) {
            this.render();
        }
    }

    debouncedRender = null;

    routesChanged(newValue, oldValue) {
        if (newValue !== oldValue) {
            clearTimeout(this.debouncedRender);
            this.debouncedRender = setTimeout(() => this.render(), 100);
        }
    }

}

let GoogleRoutingMap = () => null;
